import { render, staticRenderFns } from "./informationdetail.vue?vue&type=template&id=3a73859c&scoped=true&"
import script from "./informationdetail.vue?vue&type=script&lang=js&"
export * from "./informationdetail.vue?vue&type=script&lang=js&"
import style0 from "./informationdetail.vue?vue&type=style&index=0&id=3a73859c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a73859c",
  null
  
)

export default component.exports